<div class="modal-body">
  <p>{{ 'STORAGE_TIMER_EXPLANATION_PART_1_SHORT' | translate }}</p>
  <p>
    <strong>{{ 'STORAGE_TIMER_EXPLANATION_PART_2' | translate }}</strong>
  </p>
</div>

<div class="modal-footer">
  <button id="closeStorageTimerExplanation" class="btn btn-primary" (click)="close()">
    {{ 'OK_GOT_IT' | translate }}
  </button>
</div>
